export default __webpack_public_path__ + "_/shared_modules/continue-app/images/default-error-b8856e4447edd498ddb1148e94954127.svg";